module.exports = __webpack_public_path__ + "la.svg?635b3d0bd4b2f2854bff71670f72d22f";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/1x1/la.svg
// module id = 1206
// module chunks = 0